// eslint-disable-next-line simple-import-sort/imports
import Leaflet from 'leaflet';
import 'leaflet.pm';
import 'leaflet/dist/leaflet.css';
import 'leaflet.pm/dist/leaflet.pm.css';
import 'app/libs/leafletRuler';
import { Stack } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import { setBounds, setGeofenceChangedItem, setGeofenceMode, setGeofenceUpdateItem, setTransportConditionSelectedItem, setTransportSelectedItem, setHistorySelectedTime, } from 'app/actions/map';
import { Protect, RotatedMarker } from 'app/components';
import { GeofenceMarkerIcon, TransportConditionParkingIcon, TransportMarkerIcon, TransportMarkerSquareIcon } from 'app/icons';
import { MapLeafletCanvasMarkersLayer, MapLeafletControls, MapLeafletGeofenceDialog, MapLeafletGeofencePopup, MapLeafletGeofenceShapeChangeDialog, MapLeafletGeofenceTooltip, MapLeafletMultiColorsPolyline, MapLeafletTransportParkingTooltip, MapLeafletTransportTooltip, } from 'app/pages/Map';
import MapLeafletHistoryMarkersLayer from './MapLeafletHistoryMarkersLayer';
import { useInterval } from 'app/services';
import { geofenceOptionsUpdate } from 'app/store/map';
import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react';
import ReactDOMServer from 'react-dom/server';
import { Circle, LayerGroup, LayersControl, Map, Marker, Polygon, TileLayer } from 'react-leaflet';
import { useDispatch, useSelector } from 'react-redux';
import sphereKnn from 'sphere-knn';
import HistoryTimeLime from 'app/pages/Map/History/HistoryTimeLime';
import moment from 'moment';
import { setTransportItem } from 'app/actions/issue';
import { getPointsFromData } from '../../utils/binaryPoints';
// worker-loader: classic worker script without ES module exports
// @ts-expect-error worker module is provided by worker-loader at build time
import MergeHistoryTracksWorkerModule from '../../workers/mergeHistoryTracks.worker.ts';
import { useHistoryPositions } from '../../hooks/useHistoryPositions';
const MergeHistoryTracksWorker = MergeHistoryTracksWorkerModule;
const MapLeaflet = forwardRef(function MapLeaflet(_props, ref) {
    var _a, _b;
    const mapRef = useRef(null);
    const theme = useTheme();
    const dispatch = useDispatch();
    const { zoom, bounds, layerSelected, geofenceMode, geofenceUpdatedMode, filterTab, geofenceItems, transportItems, transportWindowMinimize, transportGeofenceView, transportSelectedItem, transportConditionSelectedItem, geofenceCheckedId, geofenceUpdatedItem, geofenceChangedItem, isHistoryOpen, transportHistoryTracksItems, historyTracksVisible, historyTracksLoading, } = useSelector((state) => state.map);
    const transportCheckedItems = useSelector((state) => state.map.transportFilterCheckedType === 'filter' ? state.map.transportProcessingCheckedItems : state.map.transportCheckedItems);
    const geofenceModeRef = useRef(geofenceMode);
    const filterTabRef = useRef(filterTab);
    const historyBoundsFittedKeyRef = useRef(null);
    // Web Worker для объединения интервалов
    const mergeWorkerRef = useRef(null);
    const mergeDebounceRef = useRef(null);
    const mergeWorkerBusyRef = useRef(false);
    const [mergedHistoryTracks, setMergedHistoryTracks] = useState([]);
    const [datetimeInterval, setDatetimeInterval] = useState(moment());
    const geofenceVisible = useMemo(() => {
        return filterTab === 'geofence' || (filterTab === 'transport' && transportGeofenceView);
    }, [filterTab, transportGeofenceView]);
    const mapTelemetryDeviceTypes = ['galileosky', 'onlyWialon'];
    const isValidMapTelemetryData = (data) => data && data.geodata !== 'ERR';
    const geofenceContainsItems = useMemo(() => {
        if (!bounds || !geofenceItems || !Array.isArray(geofenceItems)) {
            return [];
        }
        if (geofenceCheckedId.length) {
            return geofenceItems.filter((geofence) => geofenceCheckedId.includes(geofence.id) &&
                bounds.contains(Leaflet.latLng(geofence.latitude, geofence.longitude)));
        }
        return geofenceItems.filter((geofence) => bounds.contains(Leaflet.latLng(geofence.latitude, geofence.longitude)));
    }, [zoom, bounds, geofenceItems, geofenceCheckedId]);
    const transportContainsItems = useMemo(() => {
        if (!transportItems || !Array.isArray(transportItems)) {
            return [];
        }
        if (!transportCheckedItems || !Array.isArray(transportCheckedItems)) {
            return [];
        }
        const filterItems = transportItems.filter((transportItem) => transportCheckedItems.includes(transportItem.id));
        return filterItems.reduce((accumulator, currentValue) => {
            const rawConditions = Array.isArray(currentValue.conditions) ? currentValue.conditions : [];
            const conditions = mapTelemetryDeviceTypes.includes(config.transportDeviceTypes[currentValue.device_type])
                ? rawConditions.filter((condition) => isValidMapTelemetryData(condition.data))
                : [];
            if (conditions.length) {
                accumulator.push(Object.assign(Object.assign({}, currentValue), { conditions }));
            }
            return accumulator;
        }, []);
    }, [zoom, bounds, transportItems, transportCheckedItems]);
    const transportTrackItems = useMemo(() => {
        var _a;
        if (!transportSelectedItem || !transportConditionSelectedItem || isHistoryOpen) {
            return [];
        }
        const deviceType = config.transportDeviceTypes[transportSelectedItem.device_type];
        return ((_a = transportSelectedItem.conditions) !== null && _a !== void 0 ? _a : []).filter((condition) => {
            var _a;
            if (condition.type !== 'message' || !condition.data) {
                return false;
            }
            if (!condition.data.lat || !condition.data.lon) {
                return false;
            }
            if (deviceType === 'galileosky' && !isValidMapTelemetryData(condition.data)) {
                return false;
            }
            return (moment(condition.datetime).isSameOrBefore(moment(transportConditionSelectedItem.datetime)) &&
                moment(condition.datetime).isSameOrAfter(moment(transportConditionSelectedItem.datetime).subtract(((_a = transportSelectedItem.conditionOptions) === null || _a === void 0 ? void 0 : _a.interval) || 24, 'hours')));
        });
    }, [transportSelectedItem, transportConditionSelectedItem, isHistoryOpen]);
    // Web Worker для вычисления позиций истории
    const { positions: historyTransportPositionItems, isComputing: historyPositionsComputing } = useHistoryPositions();
    // Упрощает массив точек для уменьшения количества вершин при отрисовке
    // Учитывает zoom и bounds карты: точки в видимой области показываются детальнее
    const simplifyTrack = useCallback((points) => {
        var _a;
        if (!points || points.length < 3)
            return points;
        // Для маленьких массивов не упрощаем
        if (points.length <= 50)
            return points;
        // Получаем текущие zoom и bounds карты
        let mapZoom = zoom;
        let mapBounds = bounds;
        // Если есть доступ к mapRef, используем актуальные значения
        const leafletMap = (_a = mapRef.current) === null || _a === void 0 ? void 0 : _a.leafletElement;
        if (leafletMap) {
            mapZoom = leafletMap.getZoom();
            mapBounds = leafletMap.getBounds();
        }
        // Базовый шаг зависит от zoom: чем больше zoom, тем меньше шаг (детальнее)
        // zoom 3-8: шаг 10 (мало деталей)
        // zoom 9-12: шаг 5 (средние детали)
        // zoom 13-18: шаг 1-2 (высокие детали)
        let baseStep;
        if (mapZoom <= 8) {
            baseStep = 5;
        }
        else if (mapZoom <= 10) {
            baseStep = 3;
        }
        else if (mapZoom <= 12) {
            baseStep = 1;
        }
        else {
            baseStep = 1;
        }
        console.log(`Zoom: ${mapZoom} | baseStep: ${baseStep}`);
        // Проверяем, находится ли точка в bounds
        const isPointInBounds = (point) => {
            if (!mapBounds)
                return true;
            return mapBounds.contains(Leaflet.latLng(point[0], point[1]));
        };
        // Проверяем, находится ли точка рядом с bounds (в расширенной области)
        // Это нужно для плавного перехода при зуме
        const isPointNearBounds = (point) => {
            if (!mapBounds)
                return true;
            const extendedBounds = mapBounds.pad(0.2); // расширяем на 20%
            return extendedBounds.contains(Leaflet.latLng(point[0], point[1]));
        };
        // Фильтруем точки с учётом их расположения
        const result = [];
        let lastAddedIndex = -1;
        for (let i = 0; i < points.length; i++) {
            const point = points[i];
            const isLast = i === points.length - 1;
            const isFirst = i === 0;
            // Всегда добавляем первую и последнюю точки
            if (isFirst || isLast) {
                result.push(point);
                lastAddedIndex = i;
                continue;
            }
            const inBounds = isPointInBounds(point);
            const nearBounds = isPointNearBounds(point);
            // Для точек внутри bounds - высокая детализация (меньший шаг)
            // Для точек около bounds - средняя детализация
            // Для точек вне bounds - низкая детализация (больший шаг)
            let step;
            if (inBounds) {
                step = baseStep;
            }
            else if (nearBounds) {
                step = baseStep * 2;
            }
            else {
                step = baseStep * 4;
            }
            // Проверяем, нужно ли добавить точку по шагу
            const indexDiff = i - lastAddedIndex;
            if (indexDiff >= step) {
                result.push(point);
                lastAddedIndex = i;
            }
        }
        // Если результат слишком маленький, возвращаем исходный массив
        if (result.length < 2 && points.length >= 2) {
            // Возвращаем хотя бы первую и последнюю точки
            return [points[0], points[points.length - 1]];
        }
        return result;
    }, [zoom, bounds]);
    // Интервалы уже отсортированы, сортировка при объединении не нужна
    // Используется только для рендеринга треков
    // Вычисления выполняются в Web Worker с debounce для избежания блокировки UI
    useEffect(() => {
        // Очищаем предыдущий таймер debounce
        if (mergeDebounceRef.current) {
            clearTimeout(mergeDebounceRef.current);
        }
        //Debounce 300ms - ждём пока данные стабилизируются
        mergeDebounceRef.current = setTimeout(() => {
            // Если воркер занят, пропускаем этот вызов
            // Следующий вызов сделает актуальные данные когда воркер освободится
            if (mergeWorkerBusyRef.current) {
                return;
            }
            if (!transportHistoryTracksItems || Object.keys(transportHistoryTracksItems).length === 0) {
                setMergedHistoryTracks([]);
                return;
            }
            // Создаём воркер если ещё не создан
            if (!mergeWorkerRef.current) {
                mergeWorkerRef.current = new MergeHistoryTracksWorker();
                mergeWorkerRef.current.onmessage = (e) => {
                    mergeWorkerBusyRef.current = false;
                    setMergedHistoryTracks(e.data.merged);
                };
                mergeWorkerRef.current.onerror = (error) => {
                    console.error('[mergeHistoryTracks] Worker error:', error);
                    mergeWorkerBusyRef.current = false;
                };
            }
            // Запускаем вычисление в воркере
            mergeWorkerBusyRef.current = true;
            mergeWorkerRef.current.postMessage({
                transportHistoryTracksItems,
                transportCheckedItems,
            });
        }, 300);
        // Cleanup при размонтировании
        return () => {
            if (mergeDebounceRef.current) {
                clearTimeout(mergeDebounceRef.current);
            }
            if (mergeWorkerRef.current) {
                mergeWorkerRef.current.terminate();
                mergeWorkerRef.current = null;
            }
            // Иначе после terminate() onmessage не придёт и busy останется true — merge больше не запустится
            mergeWorkerBusyRef.current = false;
        };
    }, [transportHistoryTracksItems, transportCheckedItems]);
    // Мемоизированные упрощённые позиции для полилиний
    const simplifiedHistoryPositions = useMemo(() => {
        if (!mergedHistoryTracks || !mergedHistoryTracks.length) {
            return [];
        }
        return mergedHistoryTracks.map((track) => ({
            id: track.id,
            positions: simplifyTrack(track.points.map((p) => { var _a; return [p.lat, p.lon, (_a = p.can_speed) !== null && _a !== void 0 ? _a : p.speed]; })),
        }));
    }, [mergedHistoryTracks, zoom, bounds]);
    const transportParkingItems = useMemo(() => {
        if (transportSelectedItem && config.transportDeviceTypes[transportSelectedItem.device_type] === 'galileosky') {
            return transportTrackItems.slice(1).reduce((accumulator, currentValue, index, array) => {
                const previousCondition = index ? array[index - 1] : transportTrackItems[0];
                const parkingStartEvent = currentValue.messages.some((message) => message.key === 'parking:start');
                const parkingEndEvent = currentValue.messages.some((message) => message.key === 'parking:off');
                if (parkingStartEvent && currentValue.data.is_parked === 1 && previousCondition.data.is_parked === 0) {
                    accumulator.push({
                        name: transportSelectedItem.name,
                        parking_time_start: currentValue.datetime,
                        lat: currentValue.data.lat,
                        lon: currentValue.data.lon,
                    });
                }
                if (parkingEndEvent && currentValue.data.is_parked === 0 && previousCondition.data.is_parked === 1 && accumulator.length !== 0) {
                    accumulator[accumulator.length - 1].interval = moment
                        .utc(moment(currentValue.datetime).diff(moment(accumulator[accumulator.length - 1].parking_time_start)))
                        .format('HH:mm:ss');
                }
                return accumulator;
            }, []);
        }
        return [];
    }, [transportSelectedItem, transportConditionSelectedItem, transportTrackItems]);
    const transportConditionSelectedValidItem = useMemo(() => {
        var _a;
        if (!transportSelectedItem || !transportConditionSelectedItem) {
            return null;
        }
        if (!mapTelemetryDeviceTypes.includes(config.transportDeviceTypes[transportSelectedItem.device_type])) {
            return null;
        }
        if (isValidMapTelemetryData(transportConditionSelectedItem.data)) {
            return transportConditionSelectedItem;
        }
        const currentIndex = ((_a = transportSelectedItem.conditions) !== null && _a !== void 0 ? _a : []).findIndex((condition) => condition.datetime === transportConditionSelectedItem.datetime && condition.type === 'message');
        if (currentIndex !== -1) {
            for (let i = currentIndex - 1; i >= 0; i--) {
                if (!transportSelectedItem.conditions[i]) {
                    return transportConditionSelectedItem;
                }
                if (isValidMapTelemetryData(transportSelectedItem.conditions[i].data) && transportSelectedItem.conditions[i].type === 'message') {
                    return transportSelectedItem.conditions[i];
                }
            }
        }
        return transportConditionSelectedItem;
    }, [transportSelectedItem, transportConditionSelectedItem]);
    const getLeafletMap = () => { var _a, _b; return (_b = (_a = mapRef.current) === null || _a === void 0 ? void 0 : _a.leafletElement) !== null && _b !== void 0 ? _b : null; };
    const handleMapLayerChange = (event) => {
        const map = getLeafletMap();
        if (!map)
            return;
        const center = map.getCenter();
        const zoom = map.getZoom();
        map.options.crs = event.name.includes('Yandex') ? Leaflet.CRS.EPSG3395 : Leaflet.CRS.EPSG3857;
        map._resetView(center, zoom, true);
    };
    const handleGeofenceBounding = () => {
        const map = getLeafletMap();
        if (!map)
            return;
        dispatch(setBounds(map.getZoom(), map.getBounds()));
    };
    const handleMapPopupClose = () => {
        var _a;
        (_a = getLeafletMap()) === null || _a === void 0 ? void 0 : _a.closePopup();
    };
    const handleTransportMarkerClick = (_event, marker) => {
        var _a, _b, _c, _d;
        const className = (_c = (_b = (_a = marker.options) === null || _a === void 0 ? void 0 : _a.icon) === null || _b === void 0 ? void 0 : _b.options) === null || _c === void 0 ? void 0 : _c.className;
        if (className !== 'leaflet-marker-icon-transport') {
            return;
        }
        const markerId = (_d = marker.options) === null || _d === void 0 ? void 0 : _d.id;
        if (markerId == null) {
            return;
        }
        const transport = transportItems === null || transportItems === void 0 ? void 0 : transportItems.find((item) => item.id === markerId);
        if (!transport) {
            return;
        }
        dispatch(setTransportSelectedItem(transport));
        dispatch(setTransportItem(transport));
    };
    const handlePolylineClick = (event) => {
        var _a;
        const lookup = sphereKnn(event.target._latlngs);
        const closestPoint = lookup(event.latlng.lat, event.latlng.lng, 1);
        if (closestPoint.length) {
            dispatch(setTransportConditionSelectedItem(((_a = transportSelectedItem.conditions) !== null && _a !== void 0 ? _a : []).find((condition) => condition.data.lat === closestPoint[0].lat && condition.data.lon === closestPoint[0].lng)));
        }
    };
    const handleHistoryPolylineClick = (event, id) => {
        var _a;
        const lookup = sphereKnn(event.target._latlngs);
        const closestPoint = lookup(event.latlng.lat, event.latlng.lng, 1);
        if (closestPoint.length) {
            // Проверка наличия трека (новая структура с интервалами)
            if (!transportHistoryTracksItems || !transportHistoryTracksItems[id]) {
                return;
            }
            // Объединяем все интервалы для поиска
            const intervals = transportHistoryTracksItems[id];
            let allPoints = [];
            if (intervals && typeof intervals === 'object') {
                Object.values(intervals).forEach((intervalData) => {
                    // Поддерживаем бинарный формат
                    const points = getPointsFromData(intervalData);
                    if (Array.isArray(points) && points.length > 0) {
                        allPoints = allPoints.concat(points);
                    }
                });
            }
            else if (Array.isArray(intervals)) {
                allPoints = intervals;
            }
            if (!allPoints.length)
                return;
            let index = allPoints.findIndex((condition) => condition.lat === closestPoint[0].lat && condition.lon === closestPoint[0].lng);
            const conditionSelectedItem = allPoints[index];
            // Если окно ТС закрыто - открываем окно для кликнутого ТС
            if (!transportSelectedItem) {
                const transport = transportItems === null || transportItems === void 0 ? void 0 : transportItems.find((item) => item.id === id);
                if (!transport) {
                    return;
                }
                dispatch(setTransportSelectedItem(transport));
                dispatch(setTransportItem(transport));
                dispatch(setTransportConditionSelectedItem(conditionSelectedItem));
                // Обновляем historySelectedTime для синхронизации таймлайна
                if (conditionSelectedItem && conditionSelectedItem.datetime) {
                    dispatch(setHistorySelectedTime(conditionSelectedItem.datetime));
                }
            }
            else if (transportSelectedItem.id === id) {
                // Если окно открыто для того же ТС - обновляем событие
                const selectedCondition = (_a = transportSelectedItem.conditions) === null || _a === void 0 ? void 0 : _a[index];
                dispatch(setTransportConditionSelectedItem(selectedCondition));
                // Обновляем historySelectedTime для синхронизации таймлайна
                if (selectedCondition && selectedCondition.datetime) {
                    dispatch(setHistorySelectedTime(selectedCondition.datetime));
                }
            }
            else {
                // Если окно открыто для другого ТС - только обновляем время на таймлайне
                // и выбираем ближайшее событие у открытой ТС
                if (conditionSelectedItem && conditionSelectedItem.datetime) {
                    const clickedTime = moment(conditionSelectedItem.datetime);
                    dispatch(setHistorySelectedTime(conditionSelectedItem.datetime));
                    // Находим ближайшее событие у открытой ТС по времени
                    if (transportSelectedItem.conditions) {
                        const conditions = transportSelectedItem.conditions.filter((condition) => condition.type === 'message');
                        if (conditions.length > 0) {
                            let closestCondition = conditions[0];
                            let minDiff = Math.abs(moment(closestCondition.datetime).diff(clickedTime));
                            for (let i = 1; i < conditions.length; i++) {
                                const diff = Math.abs(moment(conditions[i].datetime).diff(clickedTime));
                                if (diff < minDiff) {
                                    minDiff = diff;
                                    closestCondition = conditions[i];
                                }
                            }
                            // Выбираем ближайшее событие у открытой ТС
                            dispatch(setTransportConditionSelectedItem(closestCondition));
                        }
                    }
                }
            }
        }
    };
    const handleGeofenceDialogClose = () => {
        const map = getLeafletMap();
        if (geofenceUpdatedMode === 'create' && map && geofenceUpdatedItem) {
            map.eachLayer((layer) => {
                if (layer._leaflet_id === geofenceUpdatedItem.leafletId) {
                    map.removeLayer(layer);
                }
            });
        }
        dispatch(setGeofenceMode(''));
        dispatch(setGeofenceUpdateItem(null));
    };
    const handleGeofenceShapeChangeDialogClose = () => dispatch(setGeofenceChangedItem(null));
    const handleGeofenceCreate = (event) => {
        const params = {
            leafletId: event.layer._leaflet_id,
        };
        switch (event.shape) {
            case 'Circle':
                params.shape = 'Circle';
                params.radius = Math.round(event.layer.options.radius);
                params.latitude = event.layer.getLatLng().lat;
                params.longitude = event.layer.getLatLng().lng;
                break;
            case 'Polygon':
                params.shape = 'Polygon';
                params.latitude = event.layer.getBounds().getCenter().lat;
                params.longitude = event.layer.getBounds().getCenter().lng;
                params.geometry = event.layer.getLatLngs()[0].map((coordinates) => Object.values(coordinates).reverse());
                break;
        }
        dispatch(setGeofenceUpdateItem(params));
    };
    const handleGeofenceUpdateStart = (event) => {
        event.target.closePopup();
        event.target.closeTooltip();
        event.target.setStyle({
            color: theme.palette.warning.dark,
            fillColor: theme.palette.warning.dark,
        });
    };
    const handleGeofenceUpdateEnd = (event) => {
        const params = {
            type: 'coordinates',
        };
        switch (Object.prototype.hasOwnProperty.call(event.target.options, 'radius')) {
            case true:
                params.shape = 'Circle';
                params.radius = Math.round(event.target.getRadius());
                params.latitude = event.target.getLatLng().lat;
                params.longitude = event.target.getLatLng().lng;
                break;
            case false:
                params.shape = 'Polygon';
                params.latitude = event.target.getBounds().getCenter().lat;
                params.longitude = event.target.getBounds().getCenter().lng;
                params.geometry = event.target.getLatLngs()[0].map((coordinates) => Object.values(coordinates).reverse());
                break;
        }
        dispatch(geofenceOptionsUpdate(event.target.options.id, params)).then((response) => {
            event.target.setStyle({
                color: response.color,
                fillColor: response.color,
            });
        });
    };
    useImperativeHandle(ref, () => ({
        getZoom: () => { var _a; return (_a = getLeafletMap()) === null || _a === void 0 ? void 0 : _a.getZoom(); },
        getBounds: () => { var _a; return (_a = getLeafletMap()) === null || _a === void 0 ? void 0 : _a.getBounds(); },
        handleClosePopup: () => { var _a; return (_a = getLeafletMap()) === null || _a === void 0 ? void 0 : _a.closePopup(); },
        handleRulerMode: () => { var _a; return (_a = document.getElementsByClassName('leaflet-ruler')[0]) === null || _a === void 0 ? void 0 : _a.click(); },
        handleFlyTo: (coordinates, zoom = undefined) => {
            var _a;
            const map = getLeafletMap();
            if (!map)
                return;
            const coords = coordinates;
            const targetZoom = (_a = zoom) !== null && _a !== void 0 ? _a : map.getZoom();
            const targetPoint = map.project(new Leaflet.LatLng(coords[0], coords[1]), targetZoom);
            map.setView(map.unproject(transportSelectedItem && !transportWindowMinimize
                ? targetPoint.subtract([config.mapTransportViewOptions.offsetX, config.mapTransportViewOptions.offsetY])
                : targetPoint, targetZoom), targetZoom);
        },
    }));
    useInterval(() => {
        if (moment().seconds() === 0) {
            setDatetimeInterval(moment());
        }
    }, 1000);
    useEffect(() => {
        filterTabRef.current = filterTab;
    }, [filterTab]);
    // Автоматическое масштабирование карты при включении режима "машина времени"
    // Автозум срабатывает только ОДИН раз при первом открытии истории после полной загрузки данных
    // При перемещении по таймлайну автозум НЕ срабатывает
    const historyInitialZoomDoneRef = useRef(false);
    useEffect(() => {
        // Сбрасываем флаг при закрытии истории
        if (!isHistoryOpen) {
            historyBoundsFittedKeyRef.current = null;
            historyInitialZoomDoneRef.current = false;
            return;
        }
        // Если автозум уже выполнен - не выполняем его повторно
        if (historyInitialZoomDoneRef.current) {
            return;
        }
        // Не зумим пока идёт загрузка данных или вычисление позиций
        if (historyTracksLoading || historyPositionsComputing) {
            return;
        }
        // Debounce для предотвращения частых перерисовок
        const timeoutId = setTimeout(() => {
            var _a;
            // Проверяем ещё раз после debounce
            if (!isHistoryOpen || historyInitialZoomDoneRef.current) {
                return;
            }
            if (!mapRef.current || !historyTransportPositionItems || historyTransportPositionItems.length === 0) {
                return;
            }
            // Используем historyTransportPositionItems для расчёта границ
            const allPoints = historyTransportPositionItems
                .filter((item) => (item === null || item === void 0 ? void 0 : item.lat) && (item === null || item === void 0 ? void 0 : item.lon))
                .map((item) => [item.lat, item.lon]);
            if (allPoints.length === 0) {
                return;
            }
            // Выполняем автозум только один раз
            historyInitialZoomDoneRef.current = true;
            const bounds = Leaflet.latLngBounds(allPoints);
            const map = (_a = mapRef.current) === null || _a === void 0 ? void 0 : _a.leafletElement;
            if (!map)
                return;
            map.flyToBounds(bounds, {
                padding: [20, 20],
                duration: 1.5,
                maxZoom: 18,
            });
        }, 500); // Debounce 500ms
        return () => clearTimeout(timeoutId);
    }, [isHistoryOpen, historyTracksLoading, historyPositionsComputing]);
    useEffect(() => {
        const map = getLeafletMap();
        if (!(map === null || map === void 0 ? void 0 : map.pm))
            return;
        if (geofenceMode.length !== 0) {
            geofenceModeRef.current = geofenceMode;
        }
        switch (geofenceModeRef.current) {
            case 'Poly':
                if (!geofenceMode) {
                    map.pm.disableDraw('Poly');
                    break;
                }
                map.pm.enableDraw('Poly', config.mapDrawOptions);
                break;
            case 'Circle':
                if (!geofenceMode) {
                    map.pm.disableDraw('Circle');
                    break;
                }
                map.pm.enableDraw('Circle', config.mapDrawOptions);
                break;
            case 'Edit':
                map.pm.toggleGlobalEditMode();
                map.eachLayer((layer) => ['pm:markerdragstart', 'pm:markerdragend', 'pm:vertexadded', 'pm:vertexremoved'].map((event) => {
                    if (Object.prototype.hasOwnProperty.call(layer.options, 'id')) {
                        map.pm.globalEditEnabled()
                            ? event === 'pm:markerdragstart'
                                ? layer.addEventListener(event, (event) => handleGeofenceUpdateStart(event))
                                : layer.addEventListener(event, (event) => handleGeofenceUpdateEnd(event))
                            : event === 'pm:markerdragstart'
                                ? layer.removeEventListener(event, (event) => handleGeofenceUpdateStart(event))
                                : layer.removeEventListener(event, (event) => handleGeofenceUpdateEnd(event));
                    }
                }));
                break;
            case 'Drag':
                map.pm.globalEditEnabled() && map.pm.disableGlobalEditMode();
                map.pm.toggleGlobalDragMode();
                map.eachLayer((layer) => ['pm:dragstart', 'pm:dragend'].map((event) => {
                    if (Object.prototype.hasOwnProperty.call(layer.options, 'id')) {
                        map.pm.globalDragModeEnabled()
                            ? event === 'pm:dragstart'
                                ? layer.addEventListener(event, (event) => handleGeofenceUpdateStart(event))
                                : layer.addEventListener(event, (event) => handleGeofenceUpdateEnd(event))
                            : event === 'pm:dragstart'
                                ? layer.removeEventListener(event, (event) => handleGeofenceUpdateStart(event))
                                : layer.removeEventListener(event, (event) => handleGeofenceUpdateEnd(event));
                    }
                }));
                break;
        }
    }, [geofenceMode]);
    useEffect(() => {
        const map = getLeafletMap();
        if (!map)
            return;
        if (geofenceVisible && zoom >= config.mapMinGeofenceMarkerZoom) {
            map.eachLayer((layer) => {
                const tooltip = layer.getTooltip();
                if (tooltip) {
                    layer.unbindTooltip().bindTooltip(tooltip, {
                        permanent: true,
                    });
                }
            });
        }
    }, [geofenceContainsItems]);
    useEffect(() => {
        const map = getLeafletMap();
        if (!map)
            return;
        map.flyToBounds(map.getBounds());
    }, [filterTab, geofenceCheckedId]);
    useEffect(() => {
        const map = getLeafletMap();
        if (!map)
            return;
        Leaflet.control.ruler().addTo(map);
    }, []);
    useEffect(() => {
        const map = getLeafletMap();
        if (!map)
            return;
        let autoPanStart = false;
        const handleAutoPanStart = () => {
            autoPanStart = true;
        };
        const handleMoveEnd = () => {
            if (!autoPanStart) {
                handleGeofenceBounding();
            }
            autoPanStart = false;
        };
        map.pm.setLang('ru');
        map.addEventListener('pm:create', handleGeofenceCreate);
        map.addEventListener('autopanstart', handleAutoPanStart);
        map.addEventListener('moveend', handleMoveEnd);
        return () => {
            map.removeEventListener('pm:create', handleGeofenceCreate);
            map.removeEventListener('autopanstart', handleAutoPanStart);
            map.removeEventListener('moveend', handleMoveEnd);
        };
    }, []);
    useEffect(() => {
        const map = getLeafletMap();
        if (!map)
            return;
        // Создаём pane для треков (полилинии) - НИЖЕ
        if (!map.getPane('tracksPane')) {
            const pane = map.createPane('tracksPane');
            pane.style.zIndex = '650';
        }
        // Создаём pane для маркеров истории (должен быть ВЫШЕ треков)
        if (!map.getPane('historyMarkersPane')) {
            const pane = map.createPane('historyMarkersPane');
            pane.style.zIndex = '660';
        }
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'center', sx: (theme) => ({
                height: '100%',
                flex: '1 1 auto',
                '.leaflet-container': {
                    zIndex: '1000',
                    width: '100%',
                    height: '100%',
                },
                '.leaflet-control-layers': {
                    display: 'none',
                },
                '.leaflet-control-attribution svg': {
                    display: 'none!important',
                },
                '.leaflet-tooltip-bottom': {
                    fontSize: '12px',
                    fontFamily: '"Roboto",sans-serif',
                    borderRadius: theme.shape.borderRadius,
                    padding: '3px 8px',
                    // color: theme.palette.common.white,
                    backgroundColor: theme.palette.grey.dark,
                    border: 'none',
                    '&:before': {
                        borderBottomColor: 'transparent',
                    },
                },
                '.leaflet-tooltip-top': {
                    '&:before': {
                        borderTopColor: 'transparent',
                    },
                },
                '.leaflet-popup.leaflet-popup-transport, .leaflet-popup.leaflet-popup-geofence': {
                    border: '0',
                    opacity: '1',
                    padding: theme.spacing(0),
                    transition: 'none',
                    '.leaflet-popup-content-wrapper': {
                        padding: theme.spacing(0),
                        boxShadow: '0 1px 3px ' + alpha(theme.palette.grey.main, 0.12),
                    },
                    '.leaflet-popup-content, .leaflet-popup-content p': {
                        margin: theme.spacing(0),
                    },
                    '.leaflet-popup-tip': {
                        display: 'none',
                    },
                    '&:not(:empty):before': {
                        bottom: '-10px',
                        width: '10px',
                        left: '50%',
                        height: '10px',
                        zIndex: '0',
                        content: '""',
                        display: 'block',
                        position: 'absolute',
                        transform: 'translateX(-50%) translateY(-50%) rotate(45deg)',
                        boxShadow: '0 1px 3px -2px ' + alpha(theme.palette.grey.main, 0.12),
                        bgcolor: 'background.paper',
                    },
                },
                '.leaflet-marker-icon.leaflet-marker-icon-transport': {
                    border: '0',
                    bgcolor: 'transparent',
                    svg: {
                        width: '100%',
                        height: '100%',
                    },
                },
                '.leaflet-tooltip.leaflet-tooltip-bottom-transport': {
                    whiteSpace: 'nowrap',
                    padding: '0',
                    marginTop: '16px',
                    borderRadius: theme.shape.borderRadius,
                    bgcolor: 'background.paper',
                    border: 'none',
                    pointerEvents: 'auto',
                    cursor: 'pointer',
                    boxShadow: '0 1px 3px ' + alpha(theme.palette.grey.main, 0.12),
                    '&:not(:empty):before': {
                        bottom: '-10px',
                        width: '10px',
                        left: '50%',
                        height: '10px',
                        margin: '0',
                        border: '0',
                        zIndex: '0',
                        content: '""',
                        display: 'block',
                        position: 'absolute',
                        transform: 'translateX(-50%) translateY(-50%) rotate(45deg)',
                        boxShadow: '0px -2px 3px -2px ' + alpha(theme.palette.grey.main, 0.12),
                        bgcolor: 'background.paper',
                    },
                },
                '.leaflet-tooltip.leaflet-tooltip-top-geofence': Object.assign(Object.assign({ padding: '0', marginBottom: '15px', opacity: '1!important', marginTop: '-9px !important', borderRadius: theme.shape.borderRadius, bgcolor: 'background.paper', border: 'none', boxShadow: '0 1px 3px ' + alpha(theme.palette.grey.main, 0.12) }, (zoom < config.mapMinGeofenceMarkerZoom && {
                    marginTop: '-17px !important',
                    marginLeft: '-2px !important',
                })), { '&:not(:empty):before': Object.assign({ bottom: '-10px', width: '10px', left: '50%', height: '10px', margin: '0', border: '0', zIndex: '0', content: '""', display: 'block', position: 'absolute', transform: 'translateX(-50%) translateY(-50%) rotate(45deg)', boxShadow: '0px 1px 3px -2px ' + alpha(theme.palette.grey.main, 0.12), bgcolor: 'background.paper' }, (zoom < config.mapMinGeofenceMarkerZoom && {
                        width: '8px',
                        height: '8px',
                        bottom: '-8px',
                    })) }),
                '.leaflet-tooltip.leaflet-tooltip-top-transport-parking': {
                    whiteSpace: 'nowrap',
                    padding: '0',
                    marginTop: '-20px',
                    marginLeft: '-3px',
                    opacity: '1!important',
                    borderRadius: theme.shape.borderRadius,
                    bgcolor: 'background.paper',
                    border: 'none',
                    boxShadow: '0 1px 3px ' + alpha(theme.palette.grey.main, 0.12),
                },
                '.leaflet-ruler': {
                    visibility: 'hidden',
                },
                '.leaflet-ruler-bar': {
                    backgroundColor: '#FFFFFF',
                },
                '.leaflet-ruler-result-tooltip': {
                    backgroundColor: '#FFFFFF',
                    borderWidth: 'medium',
                    borderRadius: '4px',
                    fontSize: 'smaller',
                },
                '.leaflet-ruler-moving-tooltip': {
                    backgroundColor: 'rgba(255, 255, 255, 1)',
                    backgroundClip: 'padding-box',
                    borderRadius: '4px',
                    fontSize: 'smaller',
                },
                '.leaflet-ruler-plus-length': {
                    paddingLeft: '45px',
                },
                '.leaflet-canvas-icon-layer': {
                    pointerEvents: 'none',
                },
                '.leaflet-canvas-interactive': {
                    cursor: 'pointer',
                    pointerEvents: 'auto',
                },
            }) },
            React.createElement(Map, { ref: mapRef, center: ((config === null || config === void 0 ? void 0 : config.mapCenter) || [55.75, 37.62]), zoom: zoom || 6, minZoom: 3, maxZoom: 18, crs: Leaflet.CRS.EPSG3395, scrollWheelZoom: true, zoomControl: false, closePopupOnClick: false, onbaselayerchange: handleMapLayerChange },
                React.createElement(LayersControl, null,
                    React.createElement(LayersControl.BaseLayer, { name: 'Google', checked: layerSelected === 'Google' },
                        React.createElement(TileLayer, { url: 'http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', subdomains: ['mt0', 'mt1', 'mt2', 'mt3'], attribution: '&copy <a href="https://google.com/copyright" target="_blank">Google</a>' })),
                    React.createElement(LayersControl.BaseLayer, { name: 'GoogleHybrid', checked: layerSelected === 'GoogleHybrid' },
                        React.createElement(TileLayer, { url: 'https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}', subdomains: ['mt0', 'mt1', 'mt2', 'mt3'], attribution: '&copy <a href="https://google.com/copyright" target="_blank">Google</a>' })),
                    React.createElement(LayersControl.BaseLayer, { name: 'Yandex', checked: layerSelected === 'Yandex' },
                        React.createElement(TileLayer, { url: 'https://core-renderer-tiles.maps.yandex.net/tiles?l=map&x={x}&y={y}&z={z}&scale=1&lang=ru_R', attribution: '&copy <a href="https://yandex.ru/copyright" target="_blank">Yandex</a>' })),
                    React.createElement(LayersControl.BaseLayer, { name: 'YandexHybrid', checked: layerSelected === 'YandexHybrid' },
                        React.createElement(LayerGroup, null,
                            React.createElement(TileLayer, { url: 'https://core-sat.maps.yandex.net/tiles?l=sat&x={x}&y={y}&z={z}&scale=1&lang=ru_RU', attribution: '&copy <a href="https://yandex.ru/copyright" target="_blank">Yandex</a>' }),
                            React.createElement(TileLayer, { url: 'https://core-renderer-tiles.maps.yandex.net/tiles?l=skl&x={x}&y={y}&z={z}&scale=1&lang=ru_RU', attribution: '&copy <a href="https://yandex.ru/copyright" target="_blank">Yandex</a>' }))),
                    React.createElement(LayersControl.BaseLayer, { name: 'OpenStreetMap', checked: layerSelected === 'OpenStreet' },
                        React.createElement(TileLayer, { url: 'http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', attribution: '&copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors' })),
                    React.createElement(LayersControl.BaseLayer, { name: 'OpenStreetMapSatellite', checked: layerSelected === 'OpenStreetSatellite' },
                        React.createElement(TileLayer, { url: 'http://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', subdomains: ['otile1', 'otile2', 'otile3', 'otile4'], attribution: '&copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors' }))),
                !isHistoryOpen && (transportSelectedItem === null || transportSelectedItem === void 0 ? void 0 : transportSelectedItem.conditionOptions.visible) && (React.createElement(MapLeafletMultiColorsPolyline, { pane: 'tracksPane', pmIgnore: true, lineCap: 'butt', weight: 7, options: config.mapMultiColorsPolylineOptions.colors, positions: transportTrackItems.map((condition) => {
                        var _a;
                        return [
                            condition.data.lat,
                            condition.data.lon,
                            (_a = condition.data.can_speed) !== null && _a !== void 0 ? _a : condition.data.speed,
                        ];
                    }), onClick: handlePolylineClick, optionIdxFn: (point) => {
                        const speedThresholds = [30, 80, 120];
                        for (let i = 0; i < speedThresholds.length; ++i) {
                            if (point[2] <= speedThresholds[i]) {
                                return i;
                            }
                        }
                        return speedThresholds.length;
                    } })),
                !isHistoryOpen &&
                    (transportSelectedItem === null || transportSelectedItem === void 0 ? void 0 : transportSelectedItem.parkingPointsOptions.visible) &&
                    transportParkingItems.map((parkingPoint, key) => (React.createElement(Marker, { key: key, icon: Leaflet.divIcon({
                            html: ReactDOMServer.renderToString(React.createElement(TransportConditionParkingIcon, null)),
                            className: 'leaflet-marker-icon-geofence',
                            iconSize: 30,
                        }), position: [parkingPoint.lat, parkingPoint.lon] },
                        React.createElement(MapLeafletTransportParkingTooltip, { value: parkingPoint })))),
                !isHistoryOpen && (React.createElement(MapLeafletCanvasMarkersLayer, { options: { pane: 'markerPane' }, onMarkerClick: handleTransportMarkerClick },
                    transportContainsItems.map((transportItem) => (React.createElement(RotatedMarker, { pmIgnore: true, id: transportItem.id, key: transportItem.id, minTooltipZoom: config.mapMinTransportTooltipZoom, icon: Leaflet.divIcon({
                            html: transportItem.conditions[transportItem.conditions.length - 1].data.can_speed === 0
                                ? ReactDOMServer.renderToString(React.createElement(TransportMarkerSquareIcon, { fill: transportItem.color, strokeWidth: 2 }))
                                : ReactDOMServer.renderToString(React.createElement(TransportMarkerIcon, { fill: transportItem.color, strokeWidth: 2 })),
                            className: 'leaflet-marker-icon-transport',
                            iconSize: [30, 30],
                            iconAnchor: [15, 15],
                        }), rotationAngle: transportItem.conditions[transportItem.conditions.length - 1].data.can_speed !== 0 &&
                            transportItem.conditions[transportItem.conditions.length - 1].data.course, position: [
                            transportItem.conditions[transportItem.conditions.length - 1].data.lat,
                            transportItem.conditions[transportItem.conditions.length - 1].data.lon,
                        ] },
                        React.createElement(Protect, { permissions: ['read', 'readonly'], renderPermitted: () => (React.createElement(React.Fragment, null,
                                React.createElement(MapLeafletTransportTooltip, { value: transportItem, datetime: datetimeInterval, permanent: true }))), renderForbidden: () => React.createElement(MapLeafletTransportTooltip, { value: transportItem, datetime: datetimeInterval, permanent: true }) })))),
                    geofenceVisible &&
                        zoom < config.mapMinGeofenceMarkerZoom &&
                        geofenceContainsItems.map((geofence) => (React.createElement(Marker, { id: geofence.id, key: geofence.id, minTooltipZoom: config.mapMinGeofenceTooltipZoom, position: [geofence.latitude, geofence.longitude], icon: Leaflet.divIcon({
                                html: ReactDOMServer.renderToString(React.createElement(GeofenceMarkerIcon, { fill: geofence.color })),
                                className: 'leaflet-marker-icon-geofence',
                                iconSize: [30, 30],
                                iconAnchor: [15, 15],
                            }) },
                            React.createElement(Protect, { permissions: ['create', 'delete', 'update'], renderPermitted: () => (React.createElement(React.Fragment, null,
                                    React.createElement(MapLeafletGeofencePopup, { value: geofence, onClose: handleMapPopupClose }),
                                    geofence.type_id === 1 && geofence.short_name && React.createElement(MapLeafletGeofenceTooltip, { value: geofence, permanent: true }))), renderForbidden: () => (React.createElement(React.Fragment, null, geofence.type_id === 1 && geofence.short_name && React.createElement(MapLeafletGeofenceTooltip, { value: geofence, permanent: true }))) })))),
                    transportConditionSelectedValidItem &&
                        (transportCheckedItems.indexOf(transportSelectedItem.id) !== -1
                            ? transportConditionSelectedValidItem.datetime !==
                                ((_b = (_a = transportSelectedItem === null || transportSelectedItem === void 0 ? void 0 : transportSelectedItem.conditions) === null || _a === void 0 ? void 0 : _a[transportSelectedItem.conditions.length - 1]) === null || _b === void 0 ? void 0 : _b.datetime)
                            : true) && (React.createElement(React.Fragment, null,
                        !(transportConditionSelectedItem === null || transportConditionSelectedItem === void 0 ? void 0 : transportConditionSelectedItem.hdopData) && (React.createElement(RotatedMarker, { pmIgnore: true, id: transportSelectedItem.id, minTooltipZoom: config.mapMinTransportTooltipZoom, icon: Leaflet.divIcon({
                                html: transportConditionSelectedValidItem.data.can_speed === 0
                                    ? ReactDOMServer.renderToString(React.createElement(TransportMarkerSquareIcon, { fill: transportSelectedItem.color, strokeWidth: 2 }))
                                    : ReactDOMServer.renderToString(React.createElement(TransportMarkerIcon, { fill: transportSelectedItem.color, strokeWidth: 2 })),
                                className: 'leaflet-marker-icon-transport',
                                iconSize: [30, 30],
                                iconAnchor: [15, 15],
                            }), rotationAngle: (transportConditionSelectedValidItem.data.can_speed !== 0 &&
                                transportConditionSelectedValidItem.data.course), position: [transportConditionSelectedValidItem.data.lat, transportConditionSelectedValidItem.data.lon] })),
                        (transportConditionSelectedItem === null || transportConditionSelectedItem === void 0 ? void 0 : transportConditionSelectedItem.hdopData) && (React.createElement(RotatedMarker, { pmIgnore: true, id: transportSelectedItem.id, minTooltipZoom: config.mapMinTransportTooltipZoom, icon: Leaflet.divIcon({
                                html: transportConditionSelectedItem.data.can_speed === 0
                                    ? ReactDOMServer.renderToString(React.createElement(TransportMarkerSquareIcon, { fill: transportSelectedItem.color, strokeWidth: 2 }))
                                    : ReactDOMServer.renderToString(React.createElement(TransportMarkerIcon, { fill: transportSelectedItem.color, strokeWidth: 2 })),
                                className: 'leaflet-marker-icon-transport',
                                iconSize: [30, 30],
                                iconAnchor: [15, 15],
                            }), rotationAngle: (transportConditionSelectedItem.hdopData.speed !== 0 && transportConditionSelectedItem.hdopData.course), position: [transportConditionSelectedItem.hdopData.lat, transportConditionSelectedItem.hdopData.lon] })))))),
                geofenceVisible &&
                    zoom >= config.mapMinGeofenceMarkerZoom &&
                    geofenceContainsItems.map((geofence) => {
                        switch (geofence.shape) {
                            case 'Circle':
                                return (React.createElement(Circle, { id: geofence.id, key: geofence.id, weight: 2, color: geofence.color, fillColor: geofence.color, radius: geofence.radius, center: [geofence.latitude, geofence.longitude] },
                                    React.createElement(MapLeafletGeofencePopup, { value: geofence, onClose: handleMapPopupClose }),
                                    geofence.type_id === 1 && geofence.short_name && (React.createElement(Circle, { pmIgnore: true, color: 'transparent', fillColor: 'transparent', radius: 1, center: geofence.tooltipPoint },
                                        React.createElement(MapLeafletGeofenceTooltip, { value: geofence, permanent: true })))));
                            case 'Polygon':
                                return (React.createElement(Polygon, { id: geofence.id, key: geofence.id, color: geofence.color, fillColor: geofence.color, weight: 2, positions: geofence.geometry },
                                    React.createElement(MapLeafletGeofencePopup, { value: geofence, onClose: handleMapPopupClose })));
                        }
                    }),
                isHistoryOpen &&
                    historyTracksVisible &&
                    simplifiedHistoryPositions.map((item) => {
                        if (!item.positions || item.positions.length < 2)
                            return null;
                        return (React.createElement(MapLeafletMultiColorsPolyline, { key: `track_${item.id}`, pane: 'tracksPane', pmIgnore: true, lineCap: 'butt', weight: 7, options: config.mapMultiColorsPolylineOptions.colors, positions: item.positions, onClick: (e) => handleHistoryPolylineClick(e, item.id), optionIdxFn: (point) => {
                                const speedThresholds = [30, 80, 120];
                                for (let i = 0; i < speedThresholds.length; ++i) {
                                    if (point[2] <= speedThresholds[i]) {
                                        return i;
                                    }
                                }
                                return speedThresholds.length;
                            } }));
                    }),
                isHistoryOpen && (React.createElement(MapLeafletHistoryMarkersLayer, { pane: 'historyMarkersPane', markers: historyTransportPositionItems, onMarkerClick: (event, marker) => {
                        var _a;
                        // При клике на маркер открываем окно ТС
                        const transport = transportItems === null || transportItems === void 0 ? void 0 : transportItems.find((item) => item.id === marker.id);
                        if (transport) {
                            dispatch(setTransportSelectedItem(transport));
                            dispatch(setTransportItem(transport));
                            // Обновляем время на таймлайне
                            if (marker.datetime) {
                                dispatch(setHistorySelectedTime(marker.datetime));
                            }
                            else if (marker.timestamp != null || marker.time != null) {
                                const t = (_a = marker.timestamp) !== null && _a !== void 0 ? _a : marker.time;
                                const s = t > 1e12 ? moment(t).format('YYYY-MM-DD HH:mm:ss') : moment.unix(t).format('YYYY-MM-DD HH:mm:ss');
                                dispatch(setHistorySelectedTime(s));
                            }
                        }
                    } })))),
        isHistoryOpen && React.createElement(HistoryTimeLime, null),
        React.createElement(MapLeafletControls, null),
        React.createElement(MapLeafletGeofenceDialog, { open: !!geofenceUpdatedItem, onClose: handleGeofenceDialogClose, onSuccess: handleGeofenceDialogClose }),
        React.createElement(MapLeafletGeofenceShapeChangeDialog, { open: !!geofenceChangedItem, onClose: handleGeofenceShapeChangeDialogClose, onSuccess: handleGeofenceShapeChangeDialogClose })));
});
export default MapLeaflet;
